export default "__VITE_ASSET__Dst_gTJT__"